/* Keep every header control aligned with the active colour preference. */
(function () {
  if (window.NordstuaThemeBound) return;
  window.NordstuaThemeBound = true;
  const key = 'nordstua-theme';
  const root = document.documentElement;

  function sync() {
    const dark = root.getAttribute('data-theme') !== 'light';
    document.querySelectorAll('[data-theme-toggle]').forEach(button => {
      const label = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
      button.setAttribute('aria-pressed', String(dark));
      if (label) {
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      }
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-theme-toggle]');
    if (!button) return;
    const next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem(key, next); } catch {}
    sync();
  });

  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    root.setAttribute('data-theme', event.newValue === 'light' ? 'light' : 'dark');
    sync();
  });

  const observer = new MutationObserver(mutations => {
    const changed = mutations.some(mutation => {
      if (mutation.type === 'attributes') return mutation.target === root;
      return [...mutation.addedNodes].some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches('[data-theme-toggle]') || node.querySelector('[data-theme-toggle]'))
      );
    });
    if (changed) sync();
  });
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-theme'] });
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
